export default __webpack_public_path__ + "static/media/confImg.8c251d80.png";